module.exports = __webpack_public_path__ + "static/ranger-539ea826251e1be562a446bb51ff1736.png";